<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-account" icon-small title="لیست مشتریان" color="accent">
			<template v-slot:topActions>
				<div class="d-flex hidden-sm-and-down">
					<v-btn color="primary hidden-sm-and-down" dark class="mx-1" @click="add">
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						افزودن مشتری
					</v-btn>
					<v-btn color="secondary hidden-sm-and-down" dark class="mx-1" @click="importExcel">
						<v-icon dark>
							mdi-file-excel-outline
						</v-icon>
						ورود فایل اکسل مشتریان
					</v-btn>
					<v-btn color="secondary" outlined small fab class="mx-1" @click="loadData()">
						<v-icon>
							mdi-refresh
						</v-icon>
					</v-btn>
					<v-menu>
						<template v-slot:activator="{ on, attrs }">
							<v-btn icon v-bind="attrs" color="primary" v-on="on" outlined>
								<v-icon>mdi-file-excel</v-icon>
							</v-btn>
						</template>
						<v-list>
							<v-list-item link>
								<v-list-item-title>
									<export-excel-server :loading="loadingExportExcel" :fetch="fetchExcelData" :useButton="false" :items="excelMembers" :headers="headers" :fileName="excelFileName">
										دانلود اکسل همه
									</export-excel-server>
								</v-list-item-title>
							</v-list-item>
							<v-list-item link>
								<v-list-item-title>
									<export-excel :useButton="false" :items="activeTab === 0 ? members : allMembers" :headers="headers" :fileName="excelFileName">
										دانلود اکسل صفحه جاری
									</export-excel>
								</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
					<!-- <export-excel-server :loading="loadingExportExcel" :fetch="fetchExcelData" :useButton="true" class="hidden-sm-and-down" :items="excelMembers" :headers="headers" :fileName="excelFileName">

					</export-excel-server> -->
				</div>
				<v-menu class="hidden-md-and-up">
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon v-bind="attrs" v-on="on" class="hidden-md-and-up">
							<v-icon>mdi-dots-vertical</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item link>
							<v-list-item-title @click="add">افزودن مشتری</v-list-item-title>
						</v-list-item>
						<v-list-item link>
							<v-list-item-title @click="importExcel">دریافت فایل مشتریان</v-list-item-title>
						</v-list-item>
						<v-list-item link>
							<v-list-item-title>
								<export-excel :useButton="false" :items="activeTab === 0 ? members : allMembers" :headers="headers" :fileName="excelFileName">
									دریافت اکسل
								</export-excel>
							</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>

			</template>
			<div cols="12" class="pa-5 pt-0">
				<v-tabs v-model="activeTab" @change="tabChanged" background-color="transparent" centered color="secondary" slider-color="secondary">
					<v-tab :key="0">مشتریان دارای وام فعال ({{ countActives }})</v-tab>
					<v-tab :key="1">همه مشتریان ({{ countAll }})</v-tab>

					<v-tabs-items v-model="activeTab" touchless>
						<v-tab-item :key="0">
							<v-row class="justify-space-between">
								<v-col cols="12" md="6">
									<v-text-field @change="(e) => loadData(e, false)" v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
								</v-col>
								<v-col cols="12" md="3">
									<v-text-field @change="(e) => loadData(e, true)" v-model="userLoanCode" append-icon="mdi-magnify" label="جستجوی شماره وام" single-line hide-details class="mb-5" />
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12">
									<v-data-table :height="dataTableFixedHeight - 100" fixed-header :options.sync="options" :server-items-length="countActives" dense :headers="headers" :loading="loading" :items="members" :footer-props="{ 'items-per-page-options': [5, 25, 50, 100] }" :items-per-page="itemsPerPage" :search="search" class="elevation-1">
										<template v-slot:item.firstName="{ item }">
											<div>
												<div style="cursor: pointer;" class="info--text d-flex" @click="manageLoans(item)">
													{{ item.firstName }} {{ item.lastName }} {{ item.userCode ? `(کد: ${item.userCode})` : '' }}
												</div>
												<div class="grey--text"><small>موبایل: {{ item.mobile }}</small></div>
												<div class="grey--text"><small>کد ملی: {{ item.nationalCode }}</small></div>
											</div>
										</template>
										<template v-slot:item.regDate2_Persian.date="{ item }">
											<div style="direction: ltr;">{{ `${item.regDate2_Persian.date} ${item.regDate2_Persian.time !=
												'00:00:00' ? item.regDate2_Persian.time : ''}` }}</div>
										</template>
										<template v-slot:item.loanCount="{ item }">
											<div>
												<div>
													{{ item.loanCount }}
												</div>
												<div class="grey--text">
													<small>شماره وام ها: </small>
													<small>{{ item.spreadLoanCodes }}</small>
												</div>
											</div>
										</template>
										<template v-slot:item.totalLoans="{ item }">
											{{ item.totalLoans.toString().toPriceFormat() }}
										</template>
										<template v-slot:item.totalRemain="{ item }">
											&lrm;{{ item.totalRemain.toString().toPriceFormat() }}
										</template>
										<template v-slot:item.agentName="{ item }" v-if="this.checkActivePart('agent') || this.checkActivePart('customerMarketer') || this.checkActivePart('contact')">
											<div class="" style="cursor:pointer" @click="editAgent({ id: item.agentId })">{{ (item.agentName ? 'نماینده: ' + item.agentName : '') }}</div>
											<div>{{ (item.marketerName ? 'بازاریاب: ' + item.marketerName : '') }}</div>
										</template>
										<template v-slot:item.appSmsList="{ item }" class="text-center">
											<app-sms-detail :data="item.appSmsList" :entityId="item.id.toString()" category="member" />
										</template>
										<template v-slot:item.operations="{ item }">
											<div class="text-center d-flex align-center justify-center">
												<v-menu class="">
													<template v-slot:activator="{ on, attrs }">
														<v-btn icon v-bind="attrs" v-on="on" class="">
															<v-icon large color="#ccc">mdi-dots-vertical-circle</v-icon>
														</v-btn>
													</template>
													<v-list>
														<v-list-item link>
															<v-list-item-title @click="manageLoans(item)">
																<div class="d-flex">
																	<v-icon color="green">
																		mdi-cash-check
																	</v-icon>
																	مدیریت وام ها
																</div>
															</v-list-item-title>
														</v-list-item>
														<v-list-item link>
															<v-list-item-title @click="edit(item)">
																<div class="d-flex">
																	<v-icon color="secondary">
																		mdi-square-edit-outline
																	</v-icon>
																	ویرایش اطلاعات مشتری
																</div>
															</v-list-item-title>
														</v-list-item>
														<v-list-item link>
															<v-list-item-title @click="remove(item)">
																<div class="d-flex">
																	<v-icon color="pink">
																		mdi-trash-can-outline
																	</v-icon>
																	حذف مشتری
																</div>
															</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
											</div>
										</template>
									</v-data-table>
								</v-col>
							</v-row>
						</v-tab-item>
						<v-tab-item :key="1">
							<v-row class="justify-space-between">
								<v-col cols="12" md="6">
									<v-text-field @change="(e) => loadData(e, false)" v-model="search2" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
								</v-col>
								<v-col cols="12" md="3">
									<v-text-field @change="(e) => loadData(e, true)" v-model="userLoanCode2" append-icon="mdi-magnify" label="جستجوی شماره وام" single-line hide-details class="mb-5" />
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12">
									<v-data-table :height="dataTableFixedHeight - 100" fixed-header dense :options.sync="options2" :server-items-length="countAll" :headers="headers" :loading="loading" :items="allMembers" :footer-props="{ 'items-per-page-options': [5, 25, 50, 100] }" :items-per-page="itemsPerPage" :search="search2" class="elevation-1">
										<template v-slot:item.firstName="{ item }">
											<div>
												<div>
													<div style="cursor: pointer;" @click="manageLoans(item)" class="info--text">{{ item.firstName }} {{ item.lastName }} {{ item.userCode ? `(کد: ${item.userCode})` : '' }}</div>
													<div class="grey--text"><small>موبایل: {{ item.mobile }}</small></div>
													<div class="grey--text"><small>کد ملی: {{ item.nationalCode }}</small></div>
												</div>
											</div>
										</template>
										<template v-slot:item.loanCount="{ item }">
											<div>
												<div>
													{{ item.loanCount }}
												</div>
												<div class="grey--text" v-if="item.loanCount > 0">
													<small>شماره وام ها: </small>
													<small>{{ item.spreadLoanCodes }}</small>
												</div>
											</div>
										</template>
										<template v-slot:item.regDate2_Persian.date="{ item }">
											<div style="direction: ltr;">{{ `${item.regDate2_Persian.date} ${item.regDate2_Persian.time !=
												'00:00:00' ? item.regDate2_Persian.time : ''}` }}</div>
										</template>
										<template v-slot:item.totalLoans="{ item }">
											{{ item.totalLoans.toString().toPriceFormat() }}
										</template>
										<template v-slot:item.totalRemain="{ item }">
											{{ item.totalRemain.toString().toPriceFormat() }}
										</template>
										<template v-slot:item.agentName="{ item }" v-if="this.checkActivePart('agent') || this.checkActivePart('customerMarketer') || this.checkActivePart('contact')">
											<div class="" style="cursor:pointer" @click="editAgent({ id: item.agentId })">{{ (item.agentName ? 'نماینده: ' + item.agentName : '') }}</div>
											<div>{{ (item.marketerName ? 'بازاریاب: ' + item.marketerName : '') }}</div>
										</template>
										<template v-slot:item.appSmsList="{ item }" class="text-center">
											<app-sms-detail :data="item.appSmsList" :entityId="item.id.toString()" category="member" />
										</template>
										<template v-slot:item.operations="{ item }">
											<div class="text-center d-flex align-center justify-center">
												<v-menu class="">
													<template v-slot:activator="{ on, attrs }">
														<v-btn icon v-bind="attrs" v-on="on" class="">
															<v-icon large color="#ccc">mdi-dots-vertical-circle</v-icon>
														</v-btn>
													</template>
													<v-list>
														<v-list-item link>
															<v-list-item-title @click="manageLoans(item)">
																<div class="d-flex">
																	<v-icon color="green">
																		mdi-cash-check
																	</v-icon>
																	مدیریت وام ها
																</div>
															</v-list-item-title>
														</v-list-item>
														<v-list-item link>
															<v-list-item-title @click="edit(item)">
																<div class="d-flex">
																	<v-icon color="secondary">
																		mdi-square-edit-outline
																	</v-icon>
																	ویرایش اطلاعات مشتری
																</div>
															</v-list-item-title>
														</v-list-item>
														<v-list-item link>
															<v-list-item-title @click="remove(item)">
																<div class="d-flex">
																	<v-icon color="pink">
																		mdi-trash-can-outline
																	</v-icon>
																	حذف مشتری
																</div>
															</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
											</div>
										</template>
									</v-data-table>
								</v-col>
							</v-row>
						</v-tab-item>

					</v-tabs-items>
				</v-tabs>
			</div>
			<v-dialog v-model="dialogMember" scrollable persistent max-width="1000px">
				<modify-member :data="selectedMember" v-if="dialogMember" @callbck="callbck" @close="dialogMember = false" />
			</v-dialog>

			<v-dialog v-model="dialogLoansManager" scrollable max-width="1200px">
				<v-card>
					<v-card-title>
						<div><span class="headline">مدیریت وام</span></div>
						<v-spacer />
						<v-btn @click="dialogLoansManager = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<manage-loan ref="manageLoan" v-if="dialogLoansManager" :data="{ member: selectedMember }" />
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialogImportExcel" scrollable max-width="1200px">
				<v-card>
					<v-card-title>
						<div><span class="headline">دریافت فایل اکسل مشتری ها</span></div>
						<v-spacer />
						<v-btn @click="dialogImportExcel = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<member-import ref="memberImport" @upload="loadData" />
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn @click="dialogImportExcel = false">
							بستن
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialogAgent" scrollable persistent max-width="700px">
				<v-card>
					<v-card-title>
						<span class="headline">مشخصات نماینده</span>
						<v-spacer />
						<v-btn @click="dialogAgent = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container>
							<ModifyAgent :data="selectedAgent" v-if="dialogAgent" @callbck="agent_callbck" />
						</v-container>
					</v-card-text>
				</v-card>
			</v-dialog>

		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'
import ManageLoan from './ManageLoan.vue'
import MemberImport from './ImportFile/MemberImport.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

export default {
	name: 'MembersView',
	components: {
		ConfirmDlg: () => import('@/components/Confirm'),
		ModifyAgent: () => import('@/views/admin/agent/ModifyAgent'),
		'modify-member': () => import('@/views/admin/ModifyMember'),
		'manage-loan': ManageLoan,
		'member-import': MemberImport,
		'app-sms-detail': () => import('@/components/AppSmsDetails.vue'),
		'date-picker': VuePersianDatetimePicker,
	},
	data() {
		return {
			countAll: 0,
			countActives: 0,
			activeTab: 0,
			allMembersFetched: false,
			selectedAgent: {},
			selectedMember: {},
			activeMembersFetched: false,
			errorMessages: '',
			datePickerValidatioin: '',
			localData: {},
			dialogAgent: false,
			dialogLoansManager: false,
			dialogMember: false,
			dialogImportExcel: false,
			search: '',
			search2: '',
			userLoanCode: '',
			userLoanCode2: '',
			loading: false,
			loadingExportExcel: false,
			headers: [
				{
					text: 'منوها',
					align: 'center',
					sortable: false,
					value: 'operations',
					width: 50,
				},
				{
					text: 'نام',
					align: 'start',
					sortable: true,
					value: 'firstName',
					width: 175,
				},
				{
					text: 'نام خانوادگی',
					align: 'start d-none',
					sortable: true,
					value: 'lastName',
				},
				{
					text: 'کد ملی',
					align: 'center d-none',
					sortable: true,
					value: 'nationalCode',
				},
				{
					text: 'موبایل',
					align: 'center d-none',
					sortable: true,
					value: 'mobile',
				},
				{
					text: 'تعداد وام',
					align: 'center',
					sortable: true,
					value: 'loanCount',
					excel_value: '%root%',
					excel_callback: (value) => {
						let text = 'کد وام ها: ' + value.spreadLoanCodes
						return text
					}
				},
				{
					text: 'مجموع وام های دریافتی با بهره',
					align: 'center',
					sortable: true,
					value: 'totalLoans',
					width: 150,
				},
				{
					text: 'مانده اقساط',
					align: 'center',
					sortable: true,
					value: 'totalRemain',
				},
				{
					text: 'مبلغ قسط هر وام به تفکیک جدا شده با کاما',
					align: 'center d-none',
					sortable: true,
					value: 'spreadInstallments',
					width: 0,
				},
				{
					text: 'کد وام ها',
					align: 'center d-none',
					sortable: true,
					value: 'spreadLoanCodes',
					width: 0,
				},
				{
					text: 'کد مشتری',
					align: 'left d-none',
					sortable: true,
					value: 'userCode',
					width: 0,
				},
				{
					text: 'تاریخ عضویت',
					align: 'center',
					sortable: true,
					value: 'regDate2_Persian.date',
				},
				{
					text: 'نماینده/بازاریاب',
					align: 'right',
					sortable: true,
					value: 'agentName',
					width: 135,
				},
				{
					text: 'پیامک ها',
					align: 'center',
					sortable: false,
					value: 'appSmsList',
				}
			],
			excelMembers: [],
			members: [],
			allMembers: [],
			itemsPerPage: 25,
			options: {},
			options2: {},
			previousSearch: null,
			previousSearch2: null,
		}
	},
	watch: {
		options: {
			handler() {
				this.loadData()
			},
			deep: true,
		},
		options2: {
			handler() {
				this.loadData()
			},
			deep: true,
		},
	},
	mounted() {
		this.tabChanged(0)
		let agent_index = this.headers.findIndex(x => x.value === 'agentName')
		if (agent_index > -1 && !this.checkActivePart('agent') && !this.checkActivePart('customerMarketer') && !this.checkActivePart('contact'))
			this.headers[agent_index].align = 'd-none'
	},
	computed: {
		excelFileName() {
			let name = 'لیست اعضا'
			name += '.xls'
			return name
		},
	},
	methods: {
		editAgent(agent) {
			if (!agent?.id)
				return
			this.selectedAgent = agent
			this.dialogAgent = true
		},
		loadData(e, byCode) {
			if (this.loading) {
				return
			}
			let all = this.activeTab == 1
			if (!byCode && ((all && e === this.previousSearch2) || (!all && e === this.previousSearch)))
				return
			if (all) {
				this.previousSearch2 = this.search2
				this.search2 = byCode ? '' : this.search2
				this.userLoanCode2 = byCode ? this.userLoanCode2 : ''
			}
			else {
				this.previousSearch = this.search
				this.search = byCode ? '' : this.search
				this.userLoanCode = byCode ? this.userLoanCode : ''
			}
			this.loading = true
			const data = {
				sortBy: !all ? this.options.sortBy : this.options2.sortBy,
				sortDesc: !all ? this.options.sortDesc : this.options2.sortDesc,
				page: !all ? (this.options.page || 1) : (this.options2.page || 1),
				itemsPerPage: !all ? (this.options.itemsPerPage || this.itemsPerPage) : (this.options2.itemsPerPage || this.itemsPerPage),
				all: !!all,
				search: !all ? this.search : this.search2,
				userLoanCode: !all ? this.userLoanCode : this.userLoanCode2,
			}

			api.post('admin/member/DynamicList/', data)
				.then(
					response => {
						if (all) {
							this.allMembers = response.members
						} else {
							this.members = response.members
							this.activeMembersFetched = true
							this.countActives = response.countActives
						}
						this.countAll = response.countAll
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => { this.loading = false })
		},
		add() {
			this.selectedMember = { id: 0 }
			this.dialogMember = true
		},
		edit(item) {
			this.selectedMember = item
			this.dialogMember = true
		},
		async remove(item) {
			if (!item) { return }

			if (await this.$refs.confirm.open(
				'توجه',
				'آیا از حذف این آیتم مطمئن هستید؟',
			)) {
				api.post('admin/member/delete/' + item.id)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت حذف شد.')
							this.allMembersFetched = false
							this.activeMembersFetched = false
							this.members = this.activeTab == 1 ? [] : this.members
							this.allMembers = this.activeTab == 0 ? [] : this.allMembers
							this.loadData()
						})
					.catch(err => {
						toast.error(err.message)
					})
			}
		},
		agent_callbck(result) {
			this.dialogAgent = false
		},
		callbck(result) {
			this.dialogMember = false
			if (result) {
				if (this.selectedMember.id === 0) {
					this.activeTab = 1
					this.members = []
					this.activeMembersFetched = false
					this.loadData()
				} else {
					this.loadData()
				}
			}
		},
		manageLoans(item) {
			this.selectedMember = item
			this.dialogLoansManager = true
		},
		importExcel() {
			this.dialogImportExcel = true
			this.$nextTick(() => {
				this.$refs.memberImport.prepareData()
			})
		},
		tabChanged(tab) {
			if (tab == 1 && !this.allMembersFetched)
				this.loadData()
			else if (tab == 0 && !this.activeMembersFetched)
				this.loadData()
		},
		async fetchExcelData() {
			await this.exportExcel()
			if (!this.excelMembers?.length) {
				toast.error('لیست مشتریان خالی است و امکان صدور فایل اکسل وجود ندارد.')
				return
			}
			return this.excelMembers
		},
		exportExcel() {
			this.excelMembers = []
			let all = this.activeTab == 1
			this.loadingExportExcel = true
			return api.get('admin/member/List/' + all, null)
				.then(
					response => {
						this.excelMembers = response.members
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => { this.loadingExportExcel = false })
		}
	},
}
</script>
<style></style>
